import { getDashColor } from '../../styles'
import {
  GRAY_SCALE_09,
  PRIMARY_BLUE_03,
} from 'bd-web-components/src/utils/dash-colors'
import { Advance, ButtonBox, RollBack } from './styles'
import { DashboardhMediumButton } from 'bd-web-components'

export interface FlowButtonControlProps {
  rollback: any
  flowControl: boolean
  action: any
}

export const FlowButtonControl = ({
  rollback,
  flowControl,
  action,
}: FlowButtonControlProps) => {
  const hasRollback = rollback !== undefined
  return (
    <ButtonBox>
      {hasRollback && (
        <RollBack>
          <DashboardhMediumButton
            onClick={rollback}
            height="52px"
            maxWidth="100%"
            variant={'outlined'}
            borderRadius='100px'
          >
            {'Voltar'}
          </DashboardhMediumButton>
        </RollBack>
      )}
      <Advance>
        <DashboardhMediumButton
          onClick={action}
          background={flowControl ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR') : GRAY_SCALE_09}
          color={flowControl ? '#fff' : PRIMARY_BLUE_03}
          height="52px"
          width="100%"
          maxWidth="100%"
          variant={flowControl ? 'contained' : 'disabled'}
          borderRadius='100px'
        >
          {'Avançar'}
        </DashboardhMediumButton>
      </Advance>
    </ButtonBox>
  )
}
